import { normalize_id } from './template_question_mapping_helpers';

const template_question_mapping_view_methods = {
  go_to_template_forms_tab(tab = 'forms') {
    this.$router.push({
      name: 'TemplateFormManagement',
      query: {
        ...(this.$route?.query || {}),
        tab,
      },
    });
  },

  go_to_template_form_questions() {
    const form_id = this.selected_template_builder_form_id;

    if (!form_id) {
      this.show_warning(
        'Template Questions',
        'This template form is missing a builder form id, so question creation is not available yet.',
      );
      return;
    }

    this.$router.push({
      name: 'ManageQuestions',
      query: {
        form_id,
        form_name: this.resolved_template_form_name,
      },
    });
  },

  get_onboarding_selection_for_template(template_question_id) {
    return this.template_question_mappings[normalize_id(template_question_id)] || '';
  },

  on_change_template_mapping(template_question_id, onboarding_question_id) {
    const normalized_template_question_id = normalize_id(template_question_id);
    const normalized_onboarding_question_id = normalize_id(onboarding_question_id);
    const next = { ...(this.template_question_mappings || {}) };

    Object.keys(next).forEach((template_id) => {
      if (template_id !== normalized_template_question_id) return;
      delete next[template_id];
    });

    if (normalized_onboarding_question_id) {
      next[normalized_template_question_id] = normalized_onboarding_question_id;
    }

    this.template_question_mappings = next;
  },
};

export default template_question_mapping_view_methods;
